import React from 'react'
import { LoggedInCartConsumer } from '#src/containers/Cart'
import { Link, useHistory } from 'react-router-dom'
import CartIcon from '#src/components/Header/StandardHeader/icons/mobile/cart.svg'
import styles from './styles.css'

const LoggedInCart: React.FC = () => {
  const history = useHistory()

  return (
    <Link
      to={{
        ...history.location,
        hash: '#cart'
      }}
      className={styles.navItem}
      data-testid="mobile-cart-link"
    >
      <LoggedInCartConsumer>
        {loggedInCartContext => {
          const lineItemCount = loggedInCartContext?.order?.itemsCount

          return (
            <>
              {!!lineItemCount && <div className={styles.badge}>{lineItemCount}</div>}
              <CartIcon className={styles.cartIcon} />
            </>
          )
        }}
      </LoggedInCartConsumer>
    </Link>
  )
}

export default LoggedInCart
